import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService, StorageService } from '../../_services/index';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';

@Component({
  selector: 'app-applicationscreditcheck',
  templateUrl: './applicationscreditcheck.component.html',
  styleUrls: ['./applicationscreditcheck.component.css']
})
export class ApplicationscreditcheckComponent implements OnInit {

  text = 'Credit Check';
  currentUser: any;
  parentRouteId: any;
  sub: any;
  loan: any;
  creating_contract = false;
  has_workflow = false;
  showPicture = false;
  constructor(private dataService: DataService,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public router: Router) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }
  ngOnInit() {
    this.getSummary();
  }
  getSummary() {
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.getLoan();
    });

  }
  getLoan() {
    this.loansService.getLoanContract(this.currentUser.token, this.parentRouteId)
      .subscribe(data => {
        this.loan = data.loan;
        this.dataService.onRequestLoadingEndFromBackend.emit({loan: this.loan});
      });
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.parentRouteId });
  }
  doingDisbursement(event) {
    event.new_loan = this.loan;
    this.dataService.disbursingRequest.emit(event);
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }

}
